import OperatorLanding from './operator-landing'
import Route404 from './route404'

const Pages = {
  OperatorLanding,
  Route404
}

export default Pages
